import { render, staticRenderFns } from "./BuzzerRound.vue?vue&type=template&id=559c9988&scoped=true"
import script from "./BuzzerRound.vue?vue&type=script&lang=ts"
export * from "./BuzzerRound.vue?vue&type=script&lang=ts"
import style0 from "./BuzzerRound.vue?vue&type=style&index=0&id=559c9988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c9988",
  null
  
)

export default component.exports